import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import CSV from 'papaparse'

import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Calendar } from 'primereact/calendar';
import Isvg from 'react-inlinesvg'

import auditLogService, { AuditLog_t } from 'data/audit-log'
import codeService from 'data/codes'
import { getParser } from './controls/change-renderer'
import { local } from 'data/lib/local-json'

import { AuditLogTable_s } from './audit-log-styles'
import { ChangeRenderer } from './controls/change-renderer'
import { DownloadIcon } from 'images/icons/tools'

const resources = [
  'folder',
  'property',
  'permission'
]

const dependencies = [
  'folder',
  'users',
  'usergroup',
  'portfolio',
  'property',
  // for property
  'inflation',
  'payout',
  'area'
]

type Filters = {
  change?: string
  folderid?: string
}

export const FolderAuditLog = (props) => {
  const [data, setData] = useState<AuditLog_t[]>([])
  const [filter, setFilter] = useState<Filters>({})
  const [_codes, setCodes] = useState<any>()
  const filterLogs = (log) => {
    if (log.resource == 'property' && log.method !== 'MARK') return false
    if (!filter.change || filter.change.length < 3) return true
    const change = JSON.parse(log.change)
    if (change.event) return true
    // const paths = compare(change.old, change.new).map(c => c.path.replace(/\//g,'.'))
    // for (let path of paths) {
    //   if (path.includes(filter.change)) return true
    //   if (_.includes(_.get(change.old, path), filter.change)) return true
    //   if (_.includes(_.get(change.new, path), filter.change)) return true
    // }
    return false
  }
  useEffect(() => {
    const auditLogSubscription = auditLogService.stream().subscribe((data) => {
      setData(_.filter(data.value, filterLogs))
    })

    const codeSubscription = codeService.stream().subscribe(setCodes);

    // fetched here so children can just sub/get the stream value without repeatedly fetching
    codeService.fetch(dependencies, void 0, _.last(local('folderPath')))

    return () => {
      auditLogSubscription.unsubscribe()
      codeSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    let query: string[] = []
    for (let field in filter) {
      if (_.size(filter[field]) < 3 && !_.isDate(filter[field])) continue
      switch (field) {
        case 'created_start':
          query.push(`created=gte.${moment(filter[field]).format('YYYY-MM-DDTHH:mm:ss-07:00')}`)
          break
        case 'created_end':
          query.push(`created=lte.${moment(filter[field]).format('YYYY-MM-DDTHH:mm:ss-07:00')}`)
          break
        case 'user.email':
          query.push(`user->>email=ilike.*${filter[field]}*`)
          break
        default:
          query.push(`${field}=ilike.*${encodeURIComponent(filter[field])}*`)
      }
    }
    query.push(`folderid=eq.${_.last(local('folderPath'))}`)
    auditLogService.fetch(resources, query)

  }, [filter])

  const changevalue = (field) => (value) => {
    setFilter({...filter, [field]: value})
  }

  const change = (field) => (event) => changevalue(field)(_.get(event, 'target.value') || _.get(event, 'value'))

  const header = (label, field) =>
    <div>
      {<div className="p-column-title">{label}</div>}
      <input value={filter[field]} onChange={change(field)} className="p-inputtext p-component p-column-filter"/>
    </div>

  const dateheader = (field) =>
     <div className="p-column-filter-date-group">
        <span>
          <div className="p-column-title">Date Min</div>
          <Calendar value={filter['created_start']} onChange={change('created_start')} showTime hourFormat="12" showIcon />
        </span>
        <span>
          <div className="p-column-title">Date Max</div>
          <Calendar value={filter['created_end']} onChange={change('created_end')} showTime hourFormat="12" showIcon />
        </span>
      </div>

  return (
    <AuditLogTable_s id="audit-log-scrollable-container">
      <DataTable
        id="audit-log"
        value={data}
        paginator={true}
        rows={20}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        scrollable={true}
        paginatorPosition="bottom"
        stateStorage="custom"
        customSaveState={state => localStorage.setItem("primereact-table-preferences", JSON.stringify({rows: state.rows}))}
        customRestoreState={() => JSON.parse(localStorage.getItem("primereact-table-preferences")!)}
      >
        <Column style={{minWidth: "250px", maxWidth: "250px"}}
          field="folderpath"
          header={header('Folder Path', 'folderpath')}
        />
        <Column style={{minWidth: "250px", maxWidth: "250px"}}
          field="resourcecode"
          header={header('Property Code', 'resourcecode')}
        />
        <Column style={{minWidth: "250px", maxWidth: "250px"}}
          header={header('User', 'user.email')}
          field="user.email"
        />
        <Column style={{minWidth: "250px", maxWidth: "250px"}}
          header={header('Operation/Change','change')}
          field="change"
          body={ChangeRenderer}
        />
        <Column style={{minWidth: "450px", maxWidth: "450px"}}
          header={dateheader('created')}
          field="created"
          body={(props) => moment(new Date(props['created'])).format('YYYY-MM-DD hh:mm A')}
        />
        <Column style={{minWidth: "25px", maxWidth: "25px"}} header={<Download data={data}/>}/>
      </DataTable>
    </AuditLogTable_s>
  )
}

const Download = ({data}) => {
  const filename = 'Folder-Log'
  const download = async () => {
    const fields = {
      change: 'Change',
      created: 'Change Date',
      method: 'Change Type',
      resource: 'Location',
      user: 'User'
    }
    const methods = {
      POST: 'Create',
      PATCH: 'Update',
      DELETE: 'Delete'
    }
    data = _.cloneDeep(data)
    data = _.map(data, d => getParser(_.pick(d, ['change', 'created', 'resource', 'resourcecode', 'method', 'user']))())
    data.forEach(d => d.user = d.user.email)
    data.forEach(d => d.method = methods[d.method])
    data.forEach(d => {
      d.change = `${d.atRest}\n${_.map(d.diffs, d => `${
        d.added ? '+ ' : d.removed ? '- ' : ''
      }${
        '  '.repeat(d.indent)
      }${d.key}${'value' in d ? `:${d.value}` : ''}`).join('\n')}`
    })

    const keys = ['resource', 'resourcecode', 'user', 'created', 'method', 'change']
    const headers = _.map(keys, (k) => fields[k] || k)
    const rows = _.map(data, d => _.map(keys, k => d[k]))
    const csv = CSV.unparse([headers].concat(rows))

    const element = document.createElement('a')
    element.setAttribute(
      'href',
      'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
    )
    element.setAttribute('download', filename + '.csv')
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  return (
    <span className="log-download" onClick={download}>
      <Isvg src={DownloadIcon}/>
    </span>
  )
}
